import type { Program, ProgramTimelineContentObject } from 'models';
import { ProgramActivityTimelineItem } from './program-activity-timeline-item';
import { ProgramEventTimelineItem } from './program-event-timeline-item';
import { ProgramPollTimelineItem } from './program-poll-timeline-item';
import { ProgramPostTimelineItem } from './program-post-timeline-item';
import { ProgramWithingsOrderPostTimelineItem } from './program-withings-order-post-timeline-item';

type P = {
  'data-test-id'?: string;
  item: ProgramTimelineContentObject;
  program: Program;
};

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
const ProgramTimelineItem = ({ 'data-test-id': dataTestId, item, program }: P) => {
  switch (item.type) {
    case 'activity':
      return <ProgramActivityTimelineItem data-test-id={dataTestId} item={item} program={program} />;

    case 'event':
      return <ProgramEventTimelineItem data-test-id={dataTestId} item={item} program={program} />;

    case 'poll':
      return <ProgramPollTimelineItem data-test-id={dataTestId} item={item} program={program} />;

    case 'post':
      return <ProgramPostTimelineItem data-test-id={dataTestId} item={item} program={program} />;

    case 'withings_order_post':
      return <ProgramWithingsOrderPostTimelineItem data-test-id={dataTestId} item={item} program={program} />;
  }
};

export default ProgramTimelineItem;
